import React from 'react';
import { useTranslation } from '../../context/LanguageContext';

const SelectField = ({ label, value = '', onChange, options, className = '' }) => {
    const { isRTL } = useTranslation();
    return (
        <div className={`${className}`}>
            <label className={`block text-sm font-medium text-gray-700 mb-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                {label}
            </label>
            <div className="relative">
                <select
                    value={value || ''}
                    onChange={onChange}
                    className={`w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all duration-200 ${
                        isRTL ? 'text-right pr-4' : 'text-left pl-4'
                    }`}
                    dir={isRTL ? 'rtl' : 'ltr'}
                    style={{ 
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        appearance: 'none',
                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e")',
                        backgroundPosition: isRTL ? 'left 0.5rem center' : 'right 0.5rem center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '1.5em 1.5em',
                        paddingRight: isRTL ? '1rem' : '2.5rem',
                        paddingLeft: isRTL ? '2.5rem' : '1rem'
                    }}
                >
                    {options.map(option => (
                        <option key={option.value} value={option.value} className={isRTL ? 'text-right' : 'text-left'}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default SelectField;
